require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./truncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./truncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./truncatedtext")) : factory(root["./utils"], root["./svgicon"], root["./truncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__13__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[7],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(233);


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Button = _interopRequireDefault(__webpack_require__(234));

exports.default = _Button.default;
exports.Button = _Button.default;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _svgicon = __webpack_require__(10);

var _truncatedtext = _interopRequireDefault(__webpack_require__(13));

var _utils = __webpack_require__(5);

var _baUiCarbon = __webpack_require__(9);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 *
 */
const {
  BaPropTypes
} = _utils.propsUtils;

class Button extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
  }

  focus() {
    this._node.focus();
  }

  render() {
    const {
      // remove - remapped

      /* eslint-disable react/prop-types */
      children,
      dir,
      hasIconOnly,
      iconDescription,
      kind,
      renderIcon,
      size,
      style,
      tabIndex,
      title,

      /* eslint-enable react/prop-types */
      // remove - props deprecated
      active,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      button,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      ellipsis,
      fullWidth,
      hidden,
      hover,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      icon,
      iconLeft,
      iconRight,
      iconSize,
      intent,
      label,
      numShape,
      pageNumShape,
      set,
      textAlign,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      textDir,
      variant,
      // pass all other props to CarbonButton
      ...otherCarbonButtonProps
    } = this.props;
    const {
      // props used locally but still passed directly to the Carbon button
      disabled // eslint-disable-line react/prop-types

    } = this.props; // remap children

    let mappedChildren = children != null ? children : label;

    if (mappedChildren && typeof mappedChildren === 'string') {
      const resolvedNumShape = _utils.Bidi.resolveNumShape(pageNumShape, numShape);

      const labelStr = _utils.Bidi.reshape(mappedChildren, resolvedNumShape);

      mappedChildren = labelStr;

      if (fullWidth && ellipsis !== false || ellipsis) {
        mappedChildren = /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
          value: labelStr,
          textDir: textDir != null ? textDir : ''
        });
      }
    } // remap dir


    let mappedDir = _utils.Bidi.resolveDir(label, dir != null ? dir : '');

    if (mappedDir === '') {
      mappedDir = undefined;
    } // remap kind


    let mappedKind = kind;

    if (mappedKind === undefined) {
      const mappedSet = set != null ? set : 'primary';

      if (variant === 'frame') {
        mappedKind = 'tertiary';
      } else if (variant === 'icon' || variant === 'inline' || variant === 'frameless') {
        mappedKind = 'ghost';
      } else if (intent === 'danger') {
        mappedKind = mappedSet === 'primary' ? 'danger--primary' : 'danger';
      } else if (variant === 'barOff') {
        mappedKind = 'ghost';
      } else if (mappedSet === 'primary') {
        mappedKind = 'primary';
      } else {
        mappedKind = 'secondary';
      }
    } // remap hasIconOnly


    let mappedHasIconOnly = hasIconOnly;

    if (hasIconOnly === undefined) {
      if (variant === 'icon' || mappedChildren === undefined) {
        mappedHasIconOnly = true;
      }
    } // remap iconDescription


    let mappedIconDescription;

    if (mappedHasIconOnly) {
      var _ref;

      mappedIconDescription = (_ref = iconDescription != null ? iconDescription : title) != null ? _ref : label;
    } // remap title


    let mappedTitle;

    if (!mappedHasIconOnly) {
      mappedTitle = title != null ? title : label;
    } // remap size


    const mappedSize = size === 'normal' ? undefined : size; // remap tabIndex

    const mappedTabIndex = disabled ? -1 : tabIndex; // remap style

    let mappedStyle = { ...(fullWidth ? {
        minWidth: '100%'
      } : {}),
      ...(ellipsis ? {
        maxWidth: '100%'
      } : {}),
      ...(hidden ? {
        visibility: 'hidden'
      } : {}),
      ...(variant === 'barOff' ? {
        padding: '1px 7px 2px'
      } : {}),
      ...(variant === 'inline' || variant === 'frameless' ? {
        border: '0',
        padding: '0',
        minHeight: '0'
      } : {}),
      ...(style != null ? style : {})
    };
    mappedStyle = Object.keys(mappedStyle).length ? mappedStyle : undefined;
    let mappedRenderIcon = renderIcon;

    if (!mappedRenderIcon) {
      var _ref2;

      const mappedIcon = (_ref2 = icon != null ? icon : iconRight) != null ? _ref2 : iconLeft;

      if (mappedIcon) {
        // extract 'title' before making use of 'iconProps'
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        mappedRenderIcon = ({
          title,
          ...iconProps
        }) => (0, _svgicon.createIcon)(mappedIcon, iconSize != null ? iconSize : 'small', null, null, iconProps);
      }
    }

    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Button, (0, _extends2.default)({}, otherCarbonButtonProps, {
      dir: mappedDir,
      hasIconOnly: mappedHasIconOnly,
      iconDescription: mappedIconDescription,
      kind: mappedKind,
      ref: node => {
        this._node = node;

        this._ref(node);
      },
      renderIcon: mappedRenderIcon,
      size: mappedSize,
      style: mappedStyle,
      tabIndex: mappedTabIndex,
      title: mappedTitle
    }), mappedChildren);
  }

}

exports.default = Button;
(0, _defineProperty2.default)(Button, "propTypes", {
  /** deprecated - is ignored and not applicable to carbon button */
  active: BaPropTypes.deprecated('deprecated - is ignored and not applicable to carbon button'),

  /** deprecated - is ignored and not applicable to carbon button */
  button: BaPropTypes.deprecated('deprecated - is ignored and not applicable to carbon button'),

  /** deprecated - use child(label) and styles */
  ellipsis: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use child(label) and styles */
  fullWidth: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - set style={visibility='hidden'} */
  hidden: BaPropTypes.deprecated('deprecated - set style={visibility="hidden"}'),

  /** deprecated - is ignored and not applicable to carbon button */
  hover: BaPropTypes.deprecated('deprecated - is ignored and not applicable to carbon button'),

  /** deprecated - use renderIcon prop */
  icon: BaPropTypes.deprecated('deprecated - use renderIcon prop'),

  /** deprecated - use renderIcon prop */
  iconLeft: BaPropTypes.deprecated('deprecated - use renderIcon prop'),

  /** deprecated - use renderIcon prop */
  iconRight: BaPropTypes.deprecated('deprecated - use renderIcon prop'),

  /** depreated - Carbon button size is always 16x16 (small) */
  iconSize: BaPropTypes.deprecated('depreated - Carbon button size is always 16x16 (small)'),

  /** deprecated - use kind prop */
  intent: BaPropTypes.deprecated('deprecated - use kind prop'),

  /** deprecated - use children to pass the text on the button */
  label: BaPropTypes.deprecated('deprecated - pass the button label as its children'),

  /** deprecated - use child(label) and styles */
  numShape: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use child(label) and styles */
  pageNumShape: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use kind prop */
  set: BaPropTypes.deprecated('deprecated - use kind prop'),

  /** deprecated - Carbon button text is always left justified and vertically centered */
  textAlign: BaPropTypes.deprecated('deprecated - Carbon button text is always left justified and vertically centered'),

  /** deprecated - use child(label) and styles */
  textDir: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use kind, hasIconOnly, and styles */
  variant: BaPropTypes.deprecated('deprecated - use kind, hasIconOnly, and styles')
});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[232,0]]]);
});